import styles from './HeaderDesktop.module.css';
import {Logo} from "@/widgets/Logo/Logo.tsx";
import {SearchBar} from "@/widgets/SearchBar/SearchBar.tsx";
import {SelectionAssistance} from "@/widgets/SelectionAssistance/SelectionAssistance.tsx";
// import {Banner} from "../../../../../widgets/Banner/Banner.tsx";
// import {List} from "../../../../../ui/DataDisplay/List/List.tsx";
// import {categories} from "../../../../../mock/categories.ts";
import {Cart} from "@/widgets/Cart/Cart.tsx";
import {Login} from "@/widgets/Login/Login.tsx";
import {Phone} from "@/widgets/Phone/Phone.tsx";
import {Wrapper} from "@/ui/General/Wrapper/Wrapper.tsx";
import {Geolocation} from "@/widgets/Geolocation/Geolocation.tsx";
import {Delivery} from "@/widgets/Delivery/Delivery.tsx";

export const HeaderDesktop: React.FC = () => {
    return (
        <>
            <Wrapper bgColor='#e3e3e3' containerClassName={styles.topContent}>
                <div className={styles.leftBlock}>
                    <Geolocation />
                    <Delivery />
                </div>
                <div className={styles.rightBlock}>
                    <Cart />
                    <Login />
                    <Phone/>
                </div>
            </Wrapper>

            <Wrapper bgColor='#eee' containerClassName={styles.bottomContent}>
                <Logo/>
                <SearchBar className={styles.searchBar} placeholder='Искать по названию, артикулу или номеру детали'/>
                <SelectionAssistance/>
            </Wrapper>

            {/*<Wrapper bgColor='#eee' containerClassName={styles.categoriesWrapper}>*/}
            {/*    <div className={styles.outline}></div>*/}
            {/*    <List className={styles.categories} items={categories}/>*/}
            {/*</Wrapper>*/}

            {/*<Wrapper bgColor='#182128'>*/}
            {/*    <Banner />*/}
            {/*</Wrapper>*/}
        </>
    )
}
